import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4793f3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduction" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Hi! My name is ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" I'm a ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" developer. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", null, [
      _hoisted_2,
      _createElementVNode("strong", null, [
        _createElementVNode("ins", null, _toDisplayString(_ctx.fullName), 1)
      ]),
      _hoisted_3
    ]),
    _createElementVNode("p", null, [
      _hoisted_4,
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("mark", { key: _ctx.currentStack }, " " + _toDisplayString(_ctx.currentStack) + " ", 513)), [
            [_vShow, _ctx.currentStack]
          ])
        ]),
        _: 1
      }),
      _hoisted_5
    ])
  ]))
}